const PLAYER_COOKIE = 'gl_player';
const NAME_COOKIE = 'gl_name';
const HUB_URL = 'https://games.greglab.net';

export interface HubIdentity {
  token: string | null;
  name: string | null;
  hubUrl: string;
}

function readCookie(name: string): string | null {
  const match = `; ${document.cookie}`.split(`; ${name}=`);
  if (match.length === 2) {
    return decodeURIComponent(match.pop()!.split(';').shift()!);
  }
  return null;
}

function readParam(name: string): string | null {
  try {
    return new URLSearchParams(window.location.search).get(name);
  } catch {
    return null;
  }
}

export function getIdentity(): HubIdentity {
  let token = readCookie(PLAYER_COOKIE);
  const name = readCookie(NAME_COOKIE);
  if (!token) {
    const fromUrl = readParam('gl');
    if (fromUrl) {
      token = fromUrl;
      document.cookie = `${PLAYER_COOKIE}=${encodeURIComponent(fromUrl)}; path=/; max-age=31536000; SameSite=Lax`;
    }
  }
  return { token: token || null, name: name || null, hubUrl: HUB_URL };
}

export function lobbyUrl(): string {
  return HUB_URL;
}
